import React, { useState } from 'react';
import {
  IconButton,
  Button,
  Menu,
  MenuItem,
} from '@material-ui/core';

const MenuCustom = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const {
    buttonText,
    buttonIcon,
    buttonVariant,
    buttonColor,
    startIcon,
    endIcon,
    items = [],
    style,
    disabled = false,
  } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (a, b, c) => {
    setAnchorEl(null);
  };

  const handleItemClick = item => {
    handleClose();
    item.handler();
  }

  return (
    <>
      {!!buttonIcon && !startIcon && !endIcon ? (
        <IconButton style={style} onClick={handleClick} title={buttonText} variant={buttonVariant} color={buttonColor} disabled={disabled}>
          {buttonIcon}
        </IconButton>
      ) : (
        <Button style={style} onClick={handleClick} variant={buttonVariant} color={buttonColor} startIcon={startIcon} endIcon={endIcon} disabled={disabled}>
          {buttonText}
        </Button>
      )}

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.map((item, idx) => (
          <MenuItem key={`menu-item-${idx}`} onClick={() => handleItemClick(item)} disabled={item?.disabled}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default MenuCustom;